import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useState } from "react";

const ConfirmDialog = ({ title, yes, no, isOpen, toggle, onConfirm, message }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{title}</ModalHeader>
            <ModalBody>{message}</ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onConfirm}>{yes}</Button>
                <Button color="secondary" onClick={toggle}>{no}</Button>
            </ModalFooter>
        </Modal>
    );
};
export default ConfirmDialog;